<template>
  <div class="page-content">
    <div>
      <div class="page-title">The World Congress</div>
      <div class="text">
        The World Congress is the supreme organ of the World Federation, which
        consists of the representatives of WFUCA’s Members. It meets every four
        years. <br />
        The World Congress determines the General Rules and the guidelines of
        work of the Organization. Its duty is to set the programmes and the
        budget of WFUCA. It also elects the Members of the Executive Board and
        the President.
      </div>
      <div class="page-title">List of the World Congress of WFUCA</div>
      <div class="sub-view">
        <div class="sub-item">
          <div class="sub-title">
            The 10th Ordinary World Congress
            <div class="year">2023</div>
            <div class="country">Korea</div>
          </div>
          <div class="sub-doc">
            <div class="label">Documents：</div>
            <div class="doc-view">
              <a href="#" class="doc-item"
                >Invitation Officielle pour la 32e Session du C.E - Mexique</a
              >
              <a href="#" class="doc-item"
                >Invitation Officielle pour la 32e Session du C.E - Mexique</a
              >
              <a href="#" class="doc-item"
                >Invitation Officielle pour la 32e Session du C.E - Mexique</a
              >
            </div>
          </div>
        </div>

        <div class="sub-item">
          <div class="sub-title">
            The 9th Ordinary World Congress
            <div class="year">2015</div>
            <div class="country">China</div>
          </div>
          <div class="sub-doc">
            <div class="label">Documents：</div>
            <div class="doc-view">
              <a href="#" class="doc-item"
                >Invitation Officielle pour la 32e Session du C.E - Mexique</a
              >
            </div>
          </div>
        </div>

        <div class="sub-item">
          <div class="sub-title">
            The 8th Ordinary World Congress
            <div class="year">2011</div>
            <div class="country">Vietnam</div>
          </div>
          <div class="sub-doc">
            <div class="label">Documents：</div>
            <div class="doc-view">
              <a href="#" class="doc-item"
                >Invitation Officielle pour la 32e Session du C.E - Mexique</a
              >
            </div>
          </div>
        </div>

        <div class="sub-item">
          <div class="sub-title">
            The 7th Ordinary World Congress
            <div class="year">2007</div>
            <div class="country">Greece</div>
          </div>
        </div>
        <div class="sub-item">
          <div class="sub-title">
            The 6th Ordinary World Congress
            <div class="year">2003</div>
            <div class="country">Cyprus</div>
          </div>
        </div>
        <div class="sub-item">
          <div class="sub-title">
            The 5th Ordinary World Congress
            <div class="year">1999</div>
            <div class="country">Russia</div>
          </div>
        </div>
        <div class="sub-item">
          <div class="sub-title">
            The 4th Ordinary World Congress
            <div class="year">1995</div>
            <div class="country">Romania</div>
          </div>
        </div>
        <div class="sub-item">
          <div class="sub-title">
            The 3rd Ordinary World Congress
            <div class="year">1991</div>
            <div class="country">Senegal</div>
          </div>
        </div>
        <div class="sub-item">
          <div class="sub-title">
            The 2nd Ordinary World Congress
            <div class="year">1987</div>
            <div class="country">Spain</div>
          </div>
        </div>
        <div class="sub-item">
          <div class="sub-title">
            The 1st Ordinary World Congress
            <div class="year">1984</div>
            <div class="country">Japan</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "strategy",
  components: {},
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.page-content {
  width: 100%;

  .sub-view {
    width: 100%;
    .sub-item {
      margin-bottom: fh(20vh, pc);
      color: #333333;
      padding: fh(40vh, pc) fw(40vw, pc);
      background-color: #f7f7f7;
      border-radius: 8px;
      .sub-title {
        width: 100%;
        display: flex;
        align-items: center;
        font-size: fh(32vh, pc);
        line-height: fh(38vh, pc);
        font-weight: bold;
        margin-bottom: fh(40vh, pc);
        .year {
          margin-left: fw(60vw, pc);
          font-size: fh(24vh, pc);
          line-height: fh(30vh, pc);
          font-weight: normal;
        }
        .country {
          margin-left: fw(20vw, pc);
          font-size: fh(24vh, pc);
          line-height: fh(30vh, pc);
          font-weight: normal;
        }
      }
      .sub-doc {
        width: 100%;
        display: flex;
        font-size: fh(24vh, pc);
        line-height: fh(30vh, pc);
        display: none;
        .label {
          color: #999;
          margin-right: fw(20vw, pc);
        }
        .doc-view {
          .doc-item {
            display: block;
            color: #333;
            text-decoration: underline;
            margin-bottom: fh(24vh, pc);
            &:nth-last-child(1) {
              margin-bottom: 0;
            }
          }
        }
      }
    }
  }
  .page-title {
    font-weight: bold;
    font-size: fh(36vh, pc);
    color: #333333;
    line-height: fh(54vh, pc);
    text-align: justify;
    margin-bottom: fh(20vh, pc);
  }
  .text {
    font-size: fh(18vh, pc);
    color: #2a2a2a;
    line-height: fh(28vh, pc);
    margin-bottom: fh(60vh, pc);
  }
}
</style>
